import { render, staticRenderFns } from "./regular-order-head.vue?vue&type=template&id=911d835e&"
import script from "./regular-order-head.vue?vue&type=script&lang=js&"
export * from "./regular-order-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports